import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert, Card, CardBody, Label } from "reactstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getMantisBusiness,
  updateBusinessDahboardUrls,
} from "../../ApiCalls/backoffice";

const select = (state) => ({
  userId: state.auth.userId,
  token: state.auth.token,
});

function BusinessDashboardsTab(props) {
  const [mantisBusiness, setMantisBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dashboardUrls, setDashboardUrls] = useState([]);
  const [updating, setUpdating] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { id } = useParams();

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mantisBusiness) {
      setDashboardUrls(mantisBusiness.dashboardUrls || []);
    }
  }, [mantisBusiness]);

  async function loadData() {
    const businessRes = await getMantisBusiness(props.token, props.userId, id);
    if (businessRes.success) {
      setMantisBusiness(businessRes.mantisBusiness);
    }
    setLoading(false);
  }

  async function handleUpdateDashboardUrls() {
    setUpdating(true);
    const res = await updateBusinessDahboardUrls(
      props.userId,
      id,
      dashboardUrls,
      props.token
    );
    if (res.success) {
      setAlertMessage("Dashboards actualizados correctamente");
    } else {
      setAlertMessage("Error al actualizar los dashboards");
    }
    setUpdating(false);
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div>
      {alertMessage && (
        <Alert
          color={alertMessage.includes("Error") ? "danger" : "info"}
          isOpen={alertMessage !== ""}
          toggle={() => setAlertMessage("")}
          className="mb-3"
        >
          {alertMessage}
        </Alert>
      )}

      <Card>
        <CardBody>
          <h3 className="card-title mb-4">
            <i className="fas fa-tachometer-alt"></i> Dashboards
          </h3>
          <div className="dashboards-content">
            {dashboardUrls.length === 0 ? (
              <div
                className="no-dashboards"
                style={{ textAlign: "center", padding: "40px", color: "#999" }}
              >
                <i className="fas fa-chart-bar" style={{ fontSize: "48px" }}></i>
                <p style={{ marginTop: "15px" }}>No hay dashboards configurados</p>
              </div>
            ) : (
              <div className="dashboards-list">
                {dashboardUrls.map((url, index) => (
                  <div key={index} className="dashboard-item" style={{ marginBottom: "20px" }}>
                    <div className="dashboard-header" style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                      <h6 className="dashboard-title">Dashboard {index + 1}</h6>
                      <button
                        className="delete-button"
                        onClick={() => {
                          setDashboardUrls(dashboardUrls.filter((_, i) => i !== index));
                        }}
                        style={{ background: "none", border: "none", color: "#dc3545", cursor: "pointer" }}
                        title="Eliminar dashboard"
                      >
                        <i className="fas fa-trash-alt" />
                      </button>
                    </div>
                    <div className="dashboard-inputs">
                      <div className="input-group" style={{ marginBottom: "10px" }}>
                        <Label for={`dashboardUrl${index}`}>URL:</Label>
                        <input
                          type="text"
                          id={`dashboardUrl${index}`}
                          value={url.url || ""}
                          onChange={(e) => {
                            const newDashboardUrls = [...dashboardUrls];
                            newDashboardUrls[index].url = e.target.value;
                            setDashboardUrls(newDashboardUrls);
                          }}
                          className="form-control"
                          placeholder="https://ejemplo.com/dashboard"
                        />
                      </div>
                      <div className="input-group">
                        <Label for={`dashboardTitle${index}`}>Título:</Label>
                        <input
                          type="text"
                          id={`dashboardTitle${index}`}
                          value={url.title || ""}
                          onChange={(e) => {
                            const newDashboardUrls = [...dashboardUrls];
                            newDashboardUrls[index].title = e.target.value;
                            setDashboardUrls(newDashboardUrls);
                          }}
                          className="form-control"
                          placeholder="Nombre del dashboard"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="dashboard-actions" style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
              <Button
                onClick={() => {
                  setDashboardUrls([...dashboardUrls, { url: "", title: "" }]);
                }}
                color="success"
                outline
              >
                <i className="fas fa-plus"></i> Agregar dashboard
              </Button>
              <Button
                onClick={handleUpdateDashboardUrls}
                disabled={updating}
                color="primary"
              >
                {updating ? (
                  <span className="button-content">
                    <Spinner size="sm" />
                    Actualizando...
                  </span>
                ) : (
                  <span className="button-content">
                    <i className="fas fa-save"></i> Actualizar dashboards
                  </span>
                )}
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default connect(select)(BusinessDashboardsTab);
